import { useQuery } from "@tanstack/react-query";
import orderHistoryService from "_foundationExt/apis/transaction/orderHistory.service";
import { OrderHistoryQueryParams } from "types/Order";

export const useOrderHistoryQuery = ({
  organizationId,
  channel,
  seller,
  page = 0,
  pageSize = 6,
}: OrderHistoryQueryParams) =>
  useQuery({
    queryKey: [
      "orderHistoryShortList",
      organizationId,
      channel,
      seller,
      page,
      pageSize,
    ],
    queryFn: () =>
      orderHistoryService.getHistoricalOrderSummaries({
        customerOrganizationId: organizationId!,
        channel,
        seller,
        pageNumber: page,
        pageSize,
      }),
    enabled: !!organizationId,
    staleTime: 180_000, // 3 minutes
    gcTime: 600_000, // 10 minutes
  });

export default useOrderHistoryQuery;
